import { Fab } from '@mui/material';
import { COLORS } from '../../styles/constants';
import CustomTooltip from './CustomTooltip';
import pepperIcon from '../../images/icons/Pepper.svg';
import { FloatingButtonWrapper } from './styles';

const FloatingNavigation = ({ numberOfSimulations, currentSimulation, partDefinition, simulationRefs }) => {
	const scrollToRef = ref => {
		const yOffset = -100;
		const y = ref.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({ top: y, behavior: 'smooth' });
	};

	return (
		<>
			{Array.from({ length: numberOfSimulations }, (_, index) => (
				<FloatingButtonWrapper key={`fab-wrapper-${index}`} index={index}>
					<CustomTooltip
						title={partDefinition.simulations[numberOfSimulations - index - 1].heading}
						className="floating-button"
						dataIndex={index}>
						<Fab
							style={{
								border: '2px solid',
								borderColor: currentSimulation === numberOfSimulations - index - 1 ? COLORS.PRIMARY : 'transparent'
							}}
							color={'transparent'}
							onClick={() => scrollToRef(simulationRefs.current[numberOfSimulations - index - 1])}>
							{currentSimulation === numberOfSimulations - index - 1 && (
								<img src={pepperIcon} alt="scheme" style={{ width: '40px', marginTop: '4px' }} />
							)}
						</Fab>
					</CustomTooltip>
				</FloatingButtonWrapper>
			))}
		</>
	);
};

export default FloatingNavigation;
